import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import cx from 'classnames';
import React, { createContext } from 'react';
import FormLabel from './FormLabel';
import FormFooter from './FormFooter';
import Inline from './Inline';
import List from './List';
import ListItem from './ListItem';
import { config } from '../helpers/config';
export var RadioGroupContext = createContext();
export var RadioGroupProvider = RadioGroupContext.Provider;

var RadioGroup = function RadioGroup(_ref) {
  var _cx;

  var children = _ref.children,
      className = _ref.className,
      explanationMessage = _ref.explanationMessage,
      inline = _ref.inline,
      label = _ref.label,
      name = _ref.name,
      onChange = _ref.onChange,
      selectedValue = _ref.selectedValue,
      validationMessage = _ref.validationMessage,
      required = _ref.required,
      opts = _objectWithoutPropertiesLoose(_ref, ["children", "className", "explanationMessage", "inline", "label", "name", "onChange", "selectedValue", "validationMessage", "required"]);

  var renderChildren = function renderChildren() {
    return React.Children.map(children, function (child) {
      var onChangeFunc = function onChangeFunc() {
        onChange(name, child.props.value);
      };

      return React.createElement(RadioGroupProvider, {
        value: {
          selectedValue: selectedValue,
          name: name,
          onChange: onChangeFunc
        }
      }, inline ? child : React.createElement(ListItem, null, child));
    });
  };

  var renderItems = function renderItems() {
    if (inline) {
      return React.createElement(Inline, {
        className: "form-inlineCombo"
      }, renderChildren());
    }

    return React.createElement(List, {
      type: ['space']
    }, renderChildren());
  };

  var classes = cx('form-group', className, (_cx = {}, _cx[config.classes.notValid] = validationMessage, _cx[config.classes.required] = required, _cx));
  return React.createElement("div", Object.assign({
    className: classes
  }, opts), React.createElement(FormLabel, {
    required: required,
    id: ""
  }, label), renderItems(), React.createElement(FormFooter, {
    explanationMessage: explanationMessage,
    validationMessage: validationMessage
  }));
};

export default RadioGroup;